import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Input } from 'reactstrap';
import { FilterForm, FilterInputRow, FilterSearchRow } from '@ami/react/core';
import { appConfig } from '@ami/react/core';

export class OrderDocumentsFilterComponent extends Component {
  static propTypes = {
    filter: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onFilter: PropTypes.func.isRequired,
    selectedSearchOption: PropTypes.number.isRequired
  };

  updateFilter = (filter) =>
    this.props.onChange({ ...this.props.filter, ...filter });

  render() {
    const filterInputs = (
      <Fragment>
        {appConfig.isCustomerApp && (
          <Fragment>
            <FilterInputRow label="Part Number Prefix">
              <Input
                placeholder="Part Number Prefix (4 characters)"
                value={this.props.filter.partNumberPrefix}
                onChange={(e) =>
                  this.updateFilter({ partNumberPrefix: e.target.value })
                }
              />
            </FilterInputRow>
            <FilterInputRow label="Serial #">
              <Input
                placeholder="Serial #"
                value={this.props.filter.serialNumber}
                onChange={(e) =>
                  this.updateFilter({ serialNumber: e.target.value })
                }
              />
            </FilterInputRow>
          </Fragment>
        )}

        {appConfig.isDealerApp && (
          <Fragment>
            {this.props.selectedSearchOption === 1 && (
              <FilterInputRow label="Serial #">
                <Input
                  placeholder="Serial #"
                  value={this.props.filter.serialNumber}
                  onChange={(e) =>
                    this.updateFilter({ serialNumber: e.target.value })
                  }
                />
              </FilterInputRow>
            )}

            {this.props.selectedSearchOption === 2 && (
              <FilterInputRow label="PO #">
                <Input
                  placeholder="PO #"
                  value={this.props.filter.poNumber}
                  onChange={(e) =>
                    this.updateFilter({ poNumber: e.target.value })
                  }
                />
              </FilterInputRow>
            )}
          </Fragment>
        )}
      </Fragment>
    );
    return (
      <FilterForm onSearch={() => this.props.onFilter()}>
        {filterInputs}
        <FilterSearchRow />
      </FilterForm>
    );
  }
}
